import { VerticalSetupList } from "Settings/Components/VerticalSetupList";
import { BlankCard } from "Shared/Components/Cards/BlankCard";
import { Box, Divider, Stack } from "@mui/material";
import { Outlet, useParams } from "react-router";

export const VerticalSetupPage = () => {
	const { marketId, verticalId } = useParams();
	const paramsMarketId = marketId ? Number(marketId) : undefined;
	const paramsVerticalId = verticalId ? Number(verticalId) : undefined;

	return (
		<BlankCard sx={{ p: 2 }}>
			<Stack flexDirection="column" minHeight="80vh" spacing={2}>
				<Box>
					<VerticalSetupList />
				</Box>
				<Divider orientation="horizontal" />
				{paramsMarketId && paramsVerticalId && (
					<Box flex={1}>
						<Outlet context={{ paramsMarketId, paramsVerticalId }} />
					</Box>
				)}
			</Stack>
		</BlankCard>
	);
};
